// extracted by mini-css-extract-plugin
module.exports = {"profile_wrapper":"ViewProfile_profile_wrapper__U7oLj","profile_mainContent":"ViewProfile_profile_mainContent__1MVzm","profile_status":"ViewProfile_profile_status__tQqB3"};